import { ButtonContainer, InfoCard } from "@/components";
import { PedidosContainer } from "./style";
import { usePedidos } from "./usePedidos";

export function Pedidos() {
  const { order, formatPrice } = usePedidos();

  if (!order) {
    return (
      <PedidosContainer>
        <p>Nenhum pedido selecionado.</p>
        <ButtonContainer />
      </PedidosContainer>
    );
  }

  return (
    <PedidosContainer>
      {order.items.map((item, i) => (
        <InfoCard
          key={i}
          title={item.name}
          labels={["SKU", "Descrição do produto", "Valor", "Quantidade"]}
          values={[
            item.sellerSku || item.id,
            item.name,
            formatPrice(item.price),
            String(item.quantity),
          ]}
          imgSrc={item.imageUrl}
        />
      ))}

      <ButtonContainer />
    </PedidosContainer>
  );
}
